
<!-- <section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Thank You</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section> -->
<section class="section section-sm  summer-camp section-banner-bg-1">
    <div class="container">
        <!-- <div class="sec-title text-center">
            <h2>Thank <span >You</span></h2>
        </div> -->
        <div class="row text-justify pt-5 justify-content-center align-items-center">
            <div class="col col-lg-10 mx-auto text-center">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/thank-you.png" width="40%"
                    class="img-fluid">
                <h4 class="font-weight-bold mt-2">You heve been successfully submitted</h4>
                <a class="btn button--effect-1 w-25" routerLink="/">
                    <span>Home Page</span>
                </a>
            </div>
        </div>
    </div>
</section>
